import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Page from '@/views/Page'
import About from '@/views/About'
import LegalNotice from '@/views/LegalNotice'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/project/:name',
            name: 'Project',
            component: Page
        },
        {
            path: '/legalnotice',
            name: 'LegalNotice',
            component: LegalNotice
        },
        {path: '/vault/soundboard/', redirect: '/project/2018-soundboard'},
        {path: '*', redirect: '/'}
    ],
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve( savedPosition || { x: 0, y: 0 } )
            }, 200);
        })
    }
});

router.beforeEach((to, from, next) => {

    setTimeout(() => {
        Vue.prototype.$imageCount = 0;
        Vue.prototype.$bus.$emit('loadpage', to.path);
        Vue.prototype.$preloader.load(next);
    }, 100);
});

router.afterEach((to, from) => {
    Vue.prototype.$bus.$emit('pageloaded');
});


export default router;
